import React from 'react';
import { SearchLoadingIndicator } from './LoadingStates';

const BLMMapHeader = ({
  searchTerm,
  onSearchChange,
  selectedTable,
  onTableChange,
  showBlmPoints,
  onShowBlmPointsChange,
  showBlmNames,
  onShowBlmNamesChange,
  isSearching = false
}) => {
  return (
    <div 
      style={{ 
        display: "flex", 
        flexWrap: "wrap", 
        alignItems: "center", 
        padding: "12px 24px", 
        background: "white", 
        borderBottom: "1px solid #e2e8f0", 
        gap: 24,
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
      }}
    >
      {/* Title */}
      <div style={{ fontWeight: "bold", fontSize: 20, color: "#059669" }}>
        🏔️ Map Viewer
      </div>

      {/* Search Input with Loading Indicator */}
      <div style={{ 
        flex: 1, 
        minWidth: 220, 
        maxWidth: 400, 
        position: "relative",
        display: 'flex',
        alignItems: 'center',
        gap: 8
      }}>
        <div style={{ position: 'relative', flex: 1 }}>
          <span 
            style={{ 
              position: "absolute", 
              left: 12, 
              top: "50%", 
              transform: "translateY(-50%)", 
              color: "#64748b" 
            }}
          >
            🔍
          </span>
          <input
            type="text"
            placeholder="Search BLM Recreation Points..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            style={{ 
              width: "100%", 
              padding: "10px 16px 10px 40px", 
              borderRadius: 8, 
              border: "2px solid #e2e8f0", 
              fontSize: 14 
            }}
          />
        </div>
        {isSearching && <SearchLoadingIndicator />}
      </div>

      {/* Table Selection Checkboxes */}
      <div style={{ 
        display: 'flex', 
        flexDirection: 'row', 
        flexWrap: 'wrap', 
        gap: 12, 
        alignItems: 'center', 
        minWidth: 180 
      }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <input
            type="checkbox"
            checked={selectedTable === 'blm_facilities'}
            onChange={(e) => {
              if (e.target.checked) {
                onTableChange('blm_facilities');
                onShowBlmPointsChange(true);
                onShowBlmNamesChange(false);
              }
            }}
            style={{ width: 18, height: 18 }}
          />
          <span style={{ fontSize: 14, fontWeight: 500 }}>
            BLM Recreation Feature Location
          </span>
        </label>

        <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <input
            type="checkbox"
            checked={selectedTable === 'rec_areas'}
            onChange={(e) => {
              if (e.target.checked) {
                onTableChange('rec_areas');
                onShowBlmPointsChange(false);
                onShowBlmNamesChange(true);
              }
            }}
            style={{ width: 18, height: 18 }}
          />
          <span style={{ fontSize: 14, fontWeight: 500 }}>
            BLM Recreation Name
          </span>
        </label>
      </div>
    </div>
  );
};

export default BLMMapHeader;